import React from 'react';
import { Box, Skeleton } from '@mui/material';

function PrescriberSekeleton() {
    return (
        <Box>
            <Box className="flex-row">
                <Box className="pr-12px">
                    <Skeleton variant="circular" width={40} height={40} />
                </Box>
                <Box>
                    <Skeleton variant="text" width={70} height={20} />
                    <Skeleton variant="text" width={150} height={20} />
                </Box>
            </Box>
            <Skeleton variant="text" />
        </Box>
    );
}

export default PrescriberSekeleton;
